import React from "react"
import { Box, Text, Grid, Heading, Container } from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"

const OrderedList = ({ title, subtitle, body }) => {
  return (
    <Box sx={{ backgroundColor: "primary", py: [6, 10] }}>
      <Container>
        {title && (
          <Box
            sx={{
              borderBottom: "1px solid",
              borderColor: "primary",
              mb: 6,
            }}
          >
            <Heading
              as="h2"
              variant="h1"
              sx={{
                fontWeight: "400",
                fontSize: [6, 8],
                borderBottom: "1px solid",
                pb: [4],
                borderColor: "light",
                color: "light",
              }}
            >
              {title}
            </Heading>
          </Box>
        )}
        <Grid columns={[1, 1, "2fr 4fr"]} gap={[32, 64, 128]}>
          <Box>
            {subtitle && (
              <Heading
                color="light"
                as="h2"
                variant="h3"
                sx={{
                  mt: [0, 0],
                  fontWeight: "300",
                  pb: [4],
                }}
              >
                {subtitle}
              </Heading>
            )}
          </Box>
          <Box
            sx={{
              color: "light",
              "ol,li,h1,h2,h3,h4": {
                color: "white",
                fontWeight: "300",
              },
              ol: { listStyle: "none", counterReset: "my-awesome-counter" },
              "ol li": {
                counterIncrement: "my-awesome-counter",
                fontSize: [1, 2],
                pl: 6,
                position: "relative",
              },
              "ol li::before": {
                content: 'counter(my-awesome-counter) ". "',
                color: "light",
                fontSize: [2],
                position: "absolute",
                left: 0,
                top: [4],
                display: "flex",
                alignItems: "flex-start",
              },
              li: {
                borderBottom: "1px solid",
                borderColor: "light",
                fontSize: [2],
                mb: [0],
                py: [4],
              },
            }}
          >
            <RichContentStructuredText text={body} theme={"dark"} />
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default OrderedList
